import React, { useState, useEffect } from 'react';
import './HeroSection.css';

const HeroSection = () => {
  const headlines = [
    "Find clarity, direction, and peace with AstroIndia",
    "Understand your destiny and purpose with AstroIndia",
    "Navigate relationships and career with AstroIndia",
    "Ancient Vedic wisdom for your modern life"
  ];

  const [headlineIndex, setHeadlineIndex] = useState(0);
  const [fadeClass, setFadeClass] = useState('opacity-100');

  useEffect(() => {
    const interval = setInterval(() => {
      setFadeClass('opacity-0');
      setTimeout(() => {
        setHeadlineIndex((prev) => (prev + 1) % headlines.length);
        setFadeClass('opacity-100');
      }, 500);
    }, 4000);

    return () => clearInterval(interval);
  }, [headlines.length]);

  return (
    <section id="home" className="hero-section">
      <div className="hero-container">
        <div className="hero-title-wrapper">
          <h1 className={`hero-main-title ${fadeClass}`}>
            {(() => {
              const currentHeadline = headlines[headlineIndex];
              if (currentHeadline.includes('and') || currentHeadline.includes('with')) {
                const words = currentHeadline.split(' ');
                const breakPoint = words.findIndex(w => w === 'and' || w === 'with');
                if (breakPoint > 0) {
                  return (
                    <>
                      {words.slice(0, breakPoint).join(' ')} <br className="hero-br" />
                      {words.slice(breakPoint).join(' ')}
                    </>
                  );
                }
              } else if (currentHeadline.includes('for')) {
                // Break after "wisdom" for "Ancient Vedic wisdom for your modern life"
                const words = currentHeadline.split(' ');
                const breakPoint = words.findIndex(w => w === 'wisdom');
                if (breakPoint > 0) {
                  return (
                    <>
                      {words.slice(0, breakPoint + 1).join(' ')} <br className="hero-br" />
                      {words.slice(breakPoint + 1).join(' ')}
                    </>
                  );
                }
              }
              return currentHeadline;
            })()}
          </h1>
        </div>
        <div className="hero-trust-indicators">
          <div className="trust-item">
            <span className="check-icon">✓</span>
            <span>Daily predictions & personal Kundli</span>
          </div>
          <div className="trust-item">
            <span className="check-icon">✓</span>
            <span>Verified expert astrologers</span>
          </div>
          <div className="trust-item">
            <span className="check-icon">✓</span>
            <span>Trusted by 1.5M+ followers</span>
          </div>
        </div>
        
        <div className="hero-panels">
          <div className="hero-panel hero-panel-left">
            <h2 className="panel-title">Your Personal Astrology App for Daily Guidance</h2>
            <p className="panel-description">
              Kundli, daily predictions, remedies, and personalized insights - powered by AstroIndia.
            </p>
            <div className="app-download-buttons-left">
              <a
                href="https://apps.apple.com/in/app/astroindia/id6755298020"
                target="_blank"
                rel="noopener noreferrer"
                className="app-download-btn"
              >
                <svg className="app-icon-small" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                </svg>
                <div className="app-btn-text">
                  <span className="app-btn-label">Download on the</span>
                  <span className="app-btn-name">App Store</span>
                </div>
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.app.astroindia&pli=1"
                target="_blank"
                rel="noopener noreferrer"
                className="app-download-btn"
              >
                <svg className="app-icon-small" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                </svg>
                <div className="app-btn-text">
                  <span className="app-btn-label">GET IT ON</span>
                  <span className="app-btn-name">Google Play</span>
                </div>
              </a>
            </div>
            <div className="phone-placeholder">
              <div>
                
                <div className="phone-screen">
                  <img 
                    src="/app-screen.png"
                    alt="AstroIndia App"
                    className="phone-screen-img"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className="phone-screen-fallback" style={{display: 'none'}}>
                    <span>App Image</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="hero-panel hero-panel-right">
            <h2 className="panel-title">AstroIndia Experts App</h2>
            <p className="panel-description">
              Join India's fastest-growing astrologer platform.
            </p>
            <button 
              className="signup-astrologer-btn"
              onClick={() => {
                window.location.hash = '#for-astrologers';
                window.location.reload();
              }}
            >
              Sign Up as Astrologer
            </button>
            <div className="app-download-buttons-right">
              <a
                href="https://apps.apple.com/in/app/astroindia-expert/id6755298627"
                target="_blank"
                rel="noopener noreferrer"
                className="app-download-btn"
              >
                <svg className="app-icon-small" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                </svg>
                <div className="app-btn-text">
                  <span className="app-btn-label">Download on the</span>
                  <span className="app-btn-name">App Store</span>
                </div>
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.app.astroindiaexpert&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
                className="app-download-btn"
              >
                <svg className="app-icon-small" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                </svg>
                <div className="app-btn-text">
                  <span className="app-btn-label">GET IT ON</span>
                  <span className="app-btn-name">Google Play</span>
                </div>
              </a>
            </div>
            <div className="phone-placeholder">
              <div>
                
                <div className="phone-screen">
                  <img 
                    src="/app-screen-2.png"
                    alt="AstroIndia Experts App"
                    className="phone-screen-img phone-screen-img-right"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className="phone-screen-fallback" style={{display: 'none'}}>
                    <span>App Image</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;

